"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthProvider = AuthProvider;
exports.useAuthHeader = useAuthHeader;
exports.useAuthInfo = useAuthInfo;
var _react = _interopRequireWildcard(require("react"));
var _zod = require("zod");
var _envManager = require("../utils/envManager");
var _safeFetch = require("../utils/safe-fetch");
var _addinAuth = require("../utils/addin-auth");
var _authEvents = require("../utils/auth-events");
var _userActivity = require("../utils/user-activity");
var _addinSessionLifetime = require("@common/utils/addin-session-lifetime");
var _authStateMachine = require("../utils/auth-state-machine");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var meResponseSchema = _zod.z.object({
  userId: _zod.z.string().min(1),
  firstName: _zod.z.string().nullish().transform(function (value) {
    return value !== null && value !== void 0 ? value : "";
  }),
  lastName: _zod.z.string().nullish().transform(function (value) {
    return value !== null && value !== void 0 ? value : "";
  }),
  email: _zod.z.string(),
  permissions: _zod.z.array(_zod.z.string()).default([]),
  orgId: _zod.z.string(),
  orgName: _zod.z.string().nullable(),
  orgMetadata: _zod.z.record(_zod.z.string(), _zod.z.any()).default({}),
  authorName: _zod.z.string().nullish()
});
function authorNameFrom(me) {
  var _me$authorName;
  return (_me$authorName = me.authorName) !== null && _me$authorName !== void 0 ? _me$authorName : [me.firstName, me.lastName].filter(Boolean).join(" ") || null;
}
var AuthContext = /*#__PURE__*/(0, _react.createContext)(undefined);
var TRANSIENT_RETRY_DELAYS_MS = [2000, 5000, 10000, 20000];
function fetchMe(_x) {
  return _fetchMe.apply(this, arguments);
}
function _fetchMe() {
  _fetchMe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(apiKey) {
    var webappBaseUrl, res, _t2;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          webappBaseUrl = (0, _envManager.getEnv)("WEBAPP_API_BASE_URL");
          if (webappBaseUrl) {
            _context4.n = 1;
            break;
          }
          throw new Error("WEBAPP_API_BASE_URL is not configured");
        case 1:
          _context4.n = 2;
          return (0, _safeFetch.safeFetch)("".concat(webappBaseUrl, "/api/auth/me"), {
            headers: {
              Authorization: "Bearer ".concat(apiKey)
            }
          });
        case 2:
          res = _context4.v;
          _t2 = meResponseSchema;
          _context4.n = 3;
          return res.json();
        case 3:
          return _context4.a(2, _t2.parse.call(_t2, _context4.v));
      }
    }, _callee4);
  }));
  return _fetchMe.apply(this, arguments);
}
function buildUserData(me) {
  var perms = me.permissions;
  return {
    userId: me.userId,
    firstName: me.firstName,
    lastName: me.lastName,
    email: me.email,
    hasManageUserRulesPermission: perms.includes("dioptra:manage_user_rules"),
    hasManageManagedRulesPermission: perms.includes("dioptra:manage_managed_rules"),
    hasManagePromptsPermission: perms.includes("dioptra:manage_managed_prompts"),
    hasManageFilesPermission: perms.includes("dioptra:manage_managed_files"),
    hasManageAllFilesPermission: perms.includes("dioptra::can_manage_all_files")
  };
}
function buildShims(me) {
  var perms = me.permissions;
  var org = me.orgId ? {
    orgId: me.orgId,
    orgName: me.orgName,
    orgMetadata: me.orgMetadata
  } : null;
  return {
    userClass: {
      firstName: me.firstName,
      lastName: me.lastName,
      hasPermission: function hasPermission(orgId, permission) {
        return !!org && org.orgId === orgId && perms.includes(permission);
      }
    },
    orgHelper: {
      getOrgIds: function getOrgIds() {
        return me.orgId ? [me.orgId] : [];
      },
      getOrg: function getOrg(orgId) {
        return org && org.orgId === orgId ? org : null;
      }
    }
  };
}
function DioptraAuthProvider(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(function () {
      return (0, _addinAuth.getApiKey)();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    apiKey = _useState2[0],
    setApiKeyState = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    me = _useState4[0],
    setMe = _useState4[1];
  var stateRef = (0, _react.useRef)((0, _authStateMachine.initialAuthState)((0, _addinAuth.getApiKey)() !== null));
  var _useState5 = (0, _react.useState)(function () {
      return stateRef.current.status;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    authStatus = _useState6[0],
    setAuthStatus = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    ready = _useState8[0],
    setReady = _useState8[1];
  var transientRetryCountRef = (0, _react.useRef)(0);
  var unmountedRef = (0, _react.useRef)(false);
  var refreshIntervalMsRef = (0, _react.useRef)((0, _addinSessionLifetime.addinKeyRefreshIntervalMs)((0, _addinSessionLifetime.addinSessionLifetimeSeconds)(null)));
  (0, _react.useEffect)(function () {
    refreshIntervalMsRef.current = (0, _addinSessionLifetime.addinKeyRefreshIntervalMs)((0, _addinSessionLifetime.addinSessionLifetimeSeconds)(me === null || me === void 0 ? void 0 : me.orgMetadata));
  }, [me]);
  (0, _react.useEffect)(function () {
    unmountedRef.current = false;
    return function () {
      unmountedRef.current = true;
    };
  }, []);
  var dispatch = (0, _react.useCallback)(function (event) {
    var prev = stateRef.current;
    var _nextAuthState = (0, _authStateMachine.nextAuthState)(prev, event),
      state = _nextAuthState.state,
      clearStoredKey = _nextAuthState.clearStoredKey;
    console.warn("[dioptra-auth] ".concat(event.type, ": ").concat(prev.status, " -> ").concat(state.status).concat(clearStoredKey ? " (clearing key)" : ""));
    stateRef.current = state;
    if (clearStoredKey) {
      (0, _addinAuth.clearApiKey)();
      setApiKeyState(null);
      setMe(null);
    }
    setAuthStatus(state.status);
  }, []);
  var adoptIdentity = (0, _react.useCallback)(function (data) {
    setMe(function (prev) {
      return prev && JSON.stringify(prev) === JSON.stringify(data) ? prev : data;
    });
    dispatch({
      type: "identityLoaded"
    });
  }, [dispatch]);
  var clearSession = (0, _react.useCallback)(function () {
    dispatch({
      type: "sessionCleared"
    });
  }, [dispatch]);
  var markSessionExpired = (0, _react.useCallback)(function () {
    dispatch({
      type: "authRejected"
    });
  }, [dispatch]);
  var refreshAuthInfo = (0, _react.useCallback)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var currentKey, data, attempt, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          currentKey = (0, _addinAuth.getApiKey)();
          setApiKeyState(currentKey);
          if (currentKey) {
            _context.n = 1;
            break;
          }
          setMe(null);
          dispatch({
            type: "storedKeyMissing"
          });
          setReady(true);
          return _context.a(2);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return fetchMe(currentKey);
        case 2:
          data = _context.v;
          transientRetryCountRef.current = 0;
          adoptIdentity(data);
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error("Failed to refresh auth info", _t);
          if ((0, _authStateMachine.isAuthRejection)(_t)) {
            dispatch({
              type: "authRejected"
            });
          } else {
            dispatch({
              type: "transientError"
            });
            attempt = transientRetryCountRef.current;
            if (attempt < TRANSIENT_RETRY_DELAYS_MS.length) {
              transientRetryCountRef.current = attempt + 1;
              setTimeout(function () {
                if (!unmountedRef.current) refreshAuthInfo();
              }, TRANSIENT_RETRY_DELAYS_MS[attempt]);
            }
          }
        case 4:
          _context.p = 4;
          setReady(true);
          return _context.f(4);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3, 4, 5]]);
  })), [adoptIdentity, dispatch]);
  var loginWithKey = (0, _react.useCallback)(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(key) {
      var data;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return fetchMe(key);
          case 1:
            data = _context2.v;
            (0, _addinAuth.setApiKey)(key);
            setApiKeyState(key);
            adoptIdentity(data);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [adoptIdentity]);
  (0, _react.useEffect)(function () {
    refreshAuthInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    return (0, _authEvents.onSessionInvalid)(markSessionExpired);
  }, [markSessionExpired]);
  (0, _react.useEffect)(function () {
    if (!apiKey) return;
    var cancelled = false;
    function checkLocalExpiry() {
      if ((0, _addinAuth.isApiKeyExpiredLocally)()) {
        console.warn("[dioptra-auth] stored expiresAt is in the past → skip refresh, SessionExpiryLogout logs out");
        return true;
      }
      return false;
    }
    function tryRefresh(_x3) {
      return _tryRefresh.apply(this, arguments);
    }
    function _tryRefresh() {
      _tryRefresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(force) {
        var result, status;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!checkLocalExpiry()) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              console.log("[dioptra-auth] tryRefresh(force=".concat(force, ") starting"));
              _context3.n = 2;
              return (0, _addinAuth.refreshApiKeyOnServer)({
                force: force,
                debounceMs: refreshIntervalMsRef.current
              });
            case 2:
              result = _context3.v;
              if (!cancelled) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              if (result) {
                _context3.n = 4;
                break;
              }
              console.log("[dioptra-auth] tryRefresh: skipped (debounced or no key/url)");
              return _context3.a(2);
            case 4:
              if (!(result.ok === true)) {
                _context3.n = 5;
                break;
              }
              console.log("[dioptra-auth] tryRefresh: server extended key TTL", result);
              return _context3.a(2);
            case 5:
              console.warn("[dioptra-auth] tryRefresh: server rejected refresh", result);
              status = result.status;
              if (status === 401 || status === 403) {
                markSessionExpired();
              }
            case 6:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return _tryRefresh.apply(this, arguments);
    }
    if (checkLocalExpiry()) return;
    tryRefresh(true);
    var unsubscribeFromUserActivity = (0, _userActivity.subscribeToUserActivity)(function () {
      return tryRefresh(false);
    });
    return function () {
      cancelled = true;
      unsubscribeFromUserActivity();
    };
  }, [apiKey, markSessionExpired]);
  var authInfo = _react.default.useMemo(function () {
    var isAuthenticated = !!apiKey && !!me && authStatus === "authenticated";
    var isExpiredWithContext = !!apiKey && !!me && authStatus === "expired";
    if (!apiKey || !me) {
      return {
        accessToken: null,
        user: null,
        authorName: null,
        userClass: null,
        orgHelper: null,
        isLoggedIn: false,
        authStatus: authStatus,
        isSessionExpired: isExpiredWithContext,
        refreshAuthInfo: refreshAuthInfo,
        loginWithKey: loginWithKey,
        markSessionExpired: markSessionExpired,
        clearSession: clearSession
      };
    }
    var _buildShims = buildShims(me),
      userClass = _buildShims.userClass,
      orgHelper = _buildShims.orgHelper;
    return {
      // Only expose the key while authenticated. During "expired" the stored
      // key is dead, so we withhold it to keep accessToken consistent with
      // isLoggedIn and to stop consumers (useAuthHeader, direct readers) from
      // firing background requests with a known-bad token behind the modal.
      accessToken: isAuthenticated ? apiKey : null,
      user: buildUserData(me),
      authorName: authorNameFrom(me),
      userClass: userClass,
      orgHelper: orgHelper,
      isLoggedIn: isAuthenticated,
      authStatus: authStatus,
      isSessionExpired: isExpiredWithContext,
      refreshAuthInfo: refreshAuthInfo,
      loginWithKey: loginWithKey,
      markSessionExpired: markSessionExpired,
      clearSession: clearSession
    };
  }, [apiKey, me, authStatus, refreshAuthInfo, loginWithKey, markSessionExpired, clearSession]);
  if (!ready) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthContext.Provider, {
    value: authInfo,
    "data-sentry-element": "AuthContext.Provider",
    "data-sentry-component": "DioptraAuthProvider",
    "data-sentry-source-file": "AuthContext.tsx",
    children: children
  });
}
function AuthProvider(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DioptraAuthProvider, {
    "data-sentry-element": "DioptraAuthProvider",
    "data-sentry-component": "AuthProvider",
    "data-sentry-source-file": "AuthContext.tsx",
    children: children
  });
}
function useAuthInfo() {
  var context = (0, _react.useContext)(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthInfo must be used within AuthProvider");
  }
  return context;
}
function useAuthHeader() {
  var _useAuthInfo = useAuthInfo(),
    accessToken = _useAuthInfo.accessToken;
  return accessToken ? "Bearer ".concat(accessToken) : null;
}